import PropTypes from 'prop-types';
import { isValid, subDays } from 'date-fns';
import { compose } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider, SidebarInfo, SidebarInfoColumn } from 'components';
import SidebarSection from 'components/atoms/GefMui/SidebarSection';
import { campaignTypes } from 'constants/campaigns';
import { codelists } from 'constants/codelists';
import contactDetail from 'features/views/contactDetail';
import { fromIsoDate, stringToDate } from 'utils/apiDateTime';
import { equalOrThreeDashes } from 'utils/equalOrThreeDashes';

export const Owner = ({ contact, idkAgenciesCodelist, idkRegionsCodelist }) => {
	const { solver = {}, campaign = {}, contractEndDate } = contact;

	const { campaignName, communicationName, openLetterDate, letterPrintedDate, type } = campaign;

	const owner = contactDetail.utils.getOwnerValue(
		solver,
		idkAgenciesCodelist,
		idkRegionsCodelist,
		'shortDescription',
	);

	let letterSendDate = undefined;
	if (type === campaignTypes.X_SELL) {
		letterSendDate = openLetterDate;
	} else if (type !== campaignTypes.X_SELL && type !== undefined && letterPrintedDate) {
		letterSendDate = !isNilOrEmpty(contractEndDate) && subDays(new Date(contractEndDate), 5);
	}

	return (
		<SidebarSection heading={getLabelMessage('contactDetail:owner')}>
			<SidebarInfo>
				<SidebarInfoColumn
					attribute={getLabelMessage('contactDetail:contactSource')}
					value={`${campaignName || ''} - ${communicationName || ''}`}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('contactDetail:owner')}
					value={equalOrThreeDashes(owner)}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('contactDetail:letterSend')}
					value={
						isValid(new Date(letterSendDate)) ? stringToDate(letterSendDate) : equalOrThreeDashes(undefined)
					}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('contactDetail:psEndDate')}
					value={equalOrThreeDashes(fromIsoDate(contractEndDate))}
				/>
			</SidebarInfo>
		</SidebarSection>
	);
};

Owner.propTypes = {
	contact: PropTypes.object,
	idkAgenciesCodelist: PropTypes.array,
	idkRegionsCodelist: PropTypes.array,
};

export default compose(
	codelistProvider(codelists.idkRegions, 'idkRegionsCodelist'),
	codelistProvider(codelists.idkAgencies, 'idkAgenciesCodelist'),
)(Owner);
